// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-view-container .ql-size-small,
.ql-editor .ql-size-small {
  font-size: 12px;
  line-height: 1;
}
.ql-view-container .ql-size-large,
.ql-editor .ql-size-large {
  font-size: 1.5em;
  line-height: 1;
}
.ql-view-container .ql-size-huge,
.ql-editor .ql-size-huge {
  font-size: 2.5em;
  line-height: 1;
}
.ql-view-container p,
.ql-editor p {
  height: auto;
  margin: 0;
  padding: 0;
  line-height: normal;
}
.svg-stream-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
.node-flip-x {
  transform: scaleY(-1);
}
.node-flip-y {
  transform: scaleX(-1);
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/nodes/style.less"],"names":[],"mappings":"AAEA;;EAEI,eAAA;EACA,cAAA;AADJ;AAFA;;EAMI,gBAAA;EACA,cAAA;AAAJ;AAPA;;EAUI,gBAAA;EACA,cAAA;AACJ;AAZA;;EAeI,YAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AACJ;AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;AAFF;AAKA;EACE,qBAAA;AAHF;AAMA;EACE,qBAAA;AAJF","sourcesContent":["\n\n.ql-view-container, .ql-editor {\n  .ql-size-small {\n    font-size: 12px;\n    line-height: 1;\n  }\n  .ql-size-large {\n    font-size: 1.5em;\n    line-height: 1;\n  }\n  .ql-size-huge {\n    font-size: 2.5em;\n    line-height: 1;\n  }\n\n  p {\n    height: auto;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n  }\n  \n}\n\n.svg-stream-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n}\n\n.node-flip-x {\n  transform: scaleY(-1);\n}\n\n.node-flip-y {\n  transform: scaleX(-1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
